import http from '@/api/http';

export default {
  postToFavorite(payload) {
    return http({
      url: "/favourite-menu-items",
      method: "post",
      data: payload
    });
  },
  deleteUserFavorite(menuItemId, locationId) {
    return http({
      url: `/favourite-menu-items/${menuItemId}/${locationId}`,
      method: "delete"
    });
  }
};